var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevationUp = function SvgElevationUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "elevation_up_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#elevation_up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "m2.866 20.097 5.73-8h5.03l6.72-7.845v15.845zm.895-5.114-1.197-.862 4.08-5.717h5.04l4.604-5.379 1.134.983-5.07 5.896H7.394zm2.034 3.613h13.05v-10.3l-4.55 5.3h-4.95z"
  }))));
};
export default SvgElevationUp;